<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Phúc khảo</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <ExamFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card outlined class="elevation-0">
      <StudentCreateReviewForm :state="dialog" @closeDialog="close" @refresh="getStudentExams" />
      <div class="d-flex justify-end align-center">
        <v-spacer></v-spacer>
        <div class="d-flex justify-end align-center pr-6 py-6">
          <v-btn color="primary" class="elevation-0" @click="openCreate"> <v-icon left>mdi-plus</v-icon>Tạo đơn</v-btn>
        </div>
      </div>
      <StudentReviewTable :marks="marks" />
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ExamFilter from '../../../modules/exam/student/ExamFilter.vue'
import { GradeReview } from '../../../plugins/api'
import { get } from 'lodash'
import StudentReviewTable from '../../../modules/exam/student/StudentReviewTable.vue'
import StudentCreateReviewForm from '../../../modules/exam/student/StudentCreateReviewForm.vue'

export default {
  components: {
    ExamFilter,
    StudentReviewTable,
    StudentCreateReviewForm
  },
  data() {
    return {
      marks: [],
      dialog: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  async created() {
    this.$loading.active = true
    await this.getStudentExams()
    this.$loading.active = false
  },
  methods: {
    ...mapActions('studentExam', ['fetchStudentExams']),
    async getStudentExams(query) {
      this.$loading.active = true
      const student = get(this.user, 'student._id', null)
      const marks = await GradeReview.fetch({ student, ...query })
      this.marks = marks
      this.$loading.active = false
    },
    async onFilterChanged(params) {
      await this.getStudentExams(params)
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
